export default __webpack_public_path__ + "static/interior-demolition-single-1b2ee0ea05bbed740f1e5a2bad9361c3.jpg";